export default __webpack_public_path__ + "static/media/Group11951.bae4ac23.svg";